import { type PayloadAction, createAction, createReducer } from '@reduxjs/toolkit';
import type { BillingPersonalizationResponse } from 'reactApp/api/billing/personalization/BillingPersonalizationAPICall.types';
import { billingPersonalizationDataSource } from 'reactApp/appHelpers/featuresHelpers/features/billingPersonalization';
import { normalizeBillingPersonalizationTariffsData } from 'reactApp/modules/billingPersonalization/billingPersonalization.helpers';
import type { BillingPersonalizationState } from 'reactApp/modules/billingPersonalization/billingPersonalization.types';

const emptyBillingPersonalizationData: BillingPersonalizationResponse = {
    mtime: 0,
    data1: {},
};

export const initialState: BillingPersonalizationState = {
    isLoading: false,
    isLoaded: false,
    hasError: false,
    rawData: emptyBillingPersonalizationData,
};

export const billingPersonalizationLoadRequest = createAction('billing/personalization/load/request');
export const billingPersonalizationLoadSuccess = createAction<BillingPersonalizationResponse>('billing/personalization/load/success');
export const billingPersonalizationLoadFailure = createAction('billing/personalization/load/failure');

export const initPersonalTariffs = createAction('billing/personalization/init/personaltariffs');

export const billingPersonalizationReducer = createReducer(initialState, {
    [billingPersonalizationLoadRequest.type]: (state: BillingPersonalizationState) => {
        state.isLoading = true;
        state.isLoaded = false;
        state.hasError = false;
    },
    [billingPersonalizationLoadSuccess.type]: (
        state: BillingPersonalizationState,
        { payload }: PayloadAction<BillingPersonalizationResponse>
    ) => {
        const data = payload[billingPersonalizationDataSource];

        state.isLoading = false;
        state.isLoaded = true;
        state.hasError = false;
        state.rawData = payload;
        state.web = normalizeBillingPersonalizationTariffsData(data?.promo_quota_web);
        state.iOS = normalizeBillingPersonalizationTariffsData(data?.promo_quota_ios);
        state.android = normalizeBillingPersonalizationTariffsData(data?.promo_quota_android);
        state.webEntryPoints = normalizeBillingPersonalizationTariffsData(data?.product_mail_web);
    },
    [billingPersonalizationLoadFailure.type]: (state: BillingPersonalizationState) => {
        state.isLoading = false;
        state.isLoaded = true;
        state.hasError = true;
    },
});
